import HeroSection from './components/HeroSection';
import TreatmentDetails from './components/TreatmentDetails';
import DirectorMessage from './components/DirectorMessage';
import CompanyInfo from './components/CompanyInfo';
import { useSEO } from '../../utils/seo';

const AboutPage = () => {
  const siteUrl = typeof VITE_SITE_URL !== 'undefined' ? VITE_SITE_URL : 'https://example.com';

  useSEO({
    title: '当院について｜おかやま鍼灸院 - 岡山市の鍼灸治療',
    description: 'おかやま鍼灸院の診療内容と会社概要。岡山市北区で2000年開業、経験豊富な国家資格保持者による鍼灸治療、お灸治療、美容鍼を提供。一人ひとりに寄り添うオーダーメイド治療で痛みの根本改善を目指します。',
    keywords: '岡山市 鍼灸院 概要, おかやま鍼灸院 診療内容, 岡山 鍼灸 治療方針, 岡山市北区 鍼灸 院長, 鍼灸治療 岡山',
    canonical: `${siteUrl}/about`,
    ogType: 'website',
    schema: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "当院について",
      "description": "おかやま鍼灸院の診療内容と会社概要。岡山市北区で2000年開業、経験豊富な国家資格保持者による鍼灸治療を提供。",
      "url": `${siteUrl}/about`,
      "mainEntity": {
        "@type": "MedicalBusiness",
        "name": "おかやま鍼灸院",
        "founder": {
          "@type": "Person",
          "name": "岡山太郎",
          "jobTitle": "院長"
        },
        "foundingDate": "2000",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "○○町1-2-3",
          "addressLocality": "岡山市北区",
          "addressRegion": "岡山県",
          "addressCountry": "JP"
        }
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <main>
        <HeroSection />
        <TreatmentDetails />
        <DirectorMessage />
        <CompanyInfo />
      </main>
    </div>
  );
};

export default AboutPage;
